var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { Body } from 'syf-component-library/ui/typography';
import { colors } from 'syf-component-library/defaultTheme';
import { Textfield } from 'syf-component-library/ui/atoms';
import { Label } from 'syf-component-library/ui/atoms/Textfield/subcomponents';
import query from 'syf-component-library/const/mediaQueries';
import Icon from '../../../../../icon';
import { FAR_CIRCLE_EXCLAMATION, FAS_CHECK_CIRCLE } from '../../../../../../const/icon-props';
var Container = styled(Inset)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 502px;\n  @media ", " {\n    width: 90%;\n  }\n"], ["\n  width: 100%;\n  max-width: 502px;\n  @media ", " {\n    width: 90%;\n  }\n"])), query.lessThanSmall);
var DescriptionContainer = styled(Inset)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
export var CustomTextField = styled(Textfield)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", " {\n    color: ", ";\n  }\n"], ["\n  ", " {\n    color: ", ";\n  }\n"])), Label, function (_a) {
    var theme = _a.theme, error = _a.error;
    return error === '' ? theme.bodyText : colors.error;
});
export var CheckIcon = function () { return (_jsx(Inset, __assign({ top: "xsmall", left: "small", right: "small" }, { children: _jsx(Icon, { title: "check circle icon", color: colors.success, icon: FAS_CHECK_CIRCLE, size: "lg" }) }))); };
var ErrorWrapper = styled(Inset)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  margin-top: 1.25px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  margin-top: 1.25px;\n"])));
export var DateOfBirthInputContainer = styled(Inset)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  max-width: 340px;\n\n  @media ", " {\n    max-width: 100%;\n  }\n"], ["\n  max-width: 340px;\n\n  @media ", " {\n    max-width: 100%;\n  }\n"])), query.lessThanSmall);
export var ErrorIcon = function () {
    return (_jsx(ErrorWrapper, __assign({ right: "xsmall" }, { children: _jsx(Icon, { title: "circle error icon", color: colors.error, icon: FAR_CIRCLE_EXCLAMATION, size: "1x" }) })));
};
export var ContentWrapper = function (_a) {
    var children = _a.children;
    return (_jsx(Container, __assign({ top: "xxlarge" }, { children: _jsx(Wrapper, { children: children }) })));
};
export var Description = function (_a) {
    var description = _a.description;
    return (_jsxs(DescriptionContainer, __assign({ bottom: "medium" }, { children: [_jsx(CheckIcon, {}), _jsx(Body, { children: description })] })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
